import { createAction } from 'typesafe-actions';

import { ConfigActionType } from './actionTypes';

export const setIsServer = createAction(
  ConfigActionType.SET_IS_SERVER
)<boolean>();
